import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { CheckRounded } from "@mui/icons-material";
import { Stack } from "@mui/system";
import { useSelectedOrganization, useTranslations } from "../../hooks";
import { tagsApi } from "api";
import { LabelData } from "./label_Interface";
import { COLORS } from "./colors";
import { getTranslation } from "common";
import DialogHeader from "components/dialogs/DialogHeader";


interface CreateLabelProps {
  onAdd: (label: LabelData) => void;
  open: boolean;
  onClose: () => void;
}


export const CreateLabel: React.FC<CreateLabelProps> = ({
  onAdd,
  open,
  onClose,
}) => {
  const [labelName, setLabelName] = useState("");
  const [selectedColor, setSelectedColor] = useState<string | null>(null);
  const selectedOrganization = useSelectedOrganization();
  const organizationId = selectedOrganization?.id;
  const translations = useTranslations();

  const handleClose = () => {
    onClose();
  };

  const handleColorSelect = (color: string) => {
    setSelectedColor(color);
  };

  const handleAdd = async () => {
    if (organizationId && labelName && selectedColor) {
      try {
        const tagData = {
          name: labelName,
          color: selectedColor,
        };

        const createTag = await tagsApi.post(
          `/${organizationId}/tags`,
          tagData
        );

        if (createTag.data) {
          onAdd(createTag.data);
          setLabelName("");
          setSelectedColor(null);
          handleClose();
        } else {
        }
      } catch (err) { }
    } else {
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader onClose={handleClose}>
        {getTranslation(translations, "generic.createlabel.caption")}
        {/* <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", right: "8px", top: "8px" }}
        >
          <CloseRounded />
        </IconButton> */}
      </DialogHeader>
      <DialogContent>
        {/* <Divider variant="middle" /> */}
        <Stack direction="column" spacing={1}>
          {/* <Typography variant="subtitle2">{getTranslation(translations, "generic.title.caption")}</Typography> */}
          <TextField
            sx={{ mt: 1 }}
            label={getTranslation(translations, "generic.title.caption")}
            value={labelName}
            inputProps={{
              maxlength: 20,
            }}
            placeholder={getTranslation(
              translations,
              "generic.inserttitle.caption"
            )}
            size="small"
            onChange={(e) => setLabelName(e.target.value)}
          />
          <Typography>{getTranslation(translations, "generic.selectcolor.caption")}</Typography>
          <Grid container>
            {COLORS.map((color, index) => (
              <React.Fragment key={color}>
                <Grid
                  item
                  xs={2}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    heigth: "auto",
                    aspectRatio: "1 / 1",
                    bgcolor: color,
                    "&:hover": {
                      cursor: "pointer",
                      opacity: 0.75,
                    },
                    position: "relative",
                  }}
                  onClick={() => handleColorSelect(color)}
                >
                  {selectedColor === color && (
                    <CheckRounded
                      color="info"
                      sx={{
                        color: (_) => _.palette.getContrastText(selectedColor),
                      }}
                    />
                  )}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: "center", justifyContent: "center" }}
        >
          <Button variant="semitransparent" onClick={handleAdd}>
            {getTranslation(translations, "generic.create.caption")}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
